/* eslint-disable */
<template>
  <div class="row">
    <div class="col" id="fazerRecarga">
      <div class="accordion">
        <!-- planos -->
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Passo 1: Escolha do pacote
              </button>
            </h2>
          </div>

          <div id="collapseOne" class="collapse" :class="{ show: step == 0 }">
            <div class="card-body row">
              <div
                class="col"
                v-for="(plano, $index) of planos"
                :key="$index"
                @click="
                  form.planoSelecionado = plano;
                  step = 1;
                "
              >
                <div class="card card-pacote">
                  <div class="card-header">{{ plano.titulo }}</div>
                  <div class="card-body card-body-dark">
                    <blockquote class="blockquote col-sm-12 mb-0">
                      <p class="faixa">{{ plano.totalSmss }} smss</p>
                      <p class="valor">{{ plano.valor | money }}</p>
                      <p class="valor">
                        {{ plano.valorUn | money(3) }} por sms
                      </p>
                      <span class="melhorPreco" v-if="plano.melhorPreco"
                        >--Mais popular--</span
                      >
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- dados -->
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Passo 2: Dados de identificação
              </button>
            </h2>
          </div>

          <div id="collapseOne" class="collapse" :class="{ show: step == 1 }">
            <div class="card-body">
              <div class="row">
                <div class="card col-md-6 mt-0" style="border: none">
                  <div class="card-body">
                    <h5 class="card-title">Total de creditos:</h5>
                    <p class="card-text col-md-6 col-sm-12">
                      Valor a ser pago:
                      <big> {{ form.planoSelecionado.valor | money }} </big>
                    </p>
                    <p class="col-md-6 col-sm-12">
                      Total de SMS's:
                      <big> {{ form.planoSelecionado.totalSmss }} sms's</big>
                    </p>
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <div class="form-group col">
                    <label for="cpfcnpj">CPF/CNPJ para identificação:</label>
                    <the-mask
                      :mask="['###.###.###-##', '##.###.###/####-##']"
                      @blur.native="validaCpfCnpj"
                      placeholder="Digite seu CPF"
                      v-model="form.cpfcnpj"
                      ref="cpfcnpj"
                      id="cpfcnpj"
                      class="form-control"
                    />

                    <div
                      class="alert alert-danger mt-1"
                      v-if="cpfCnpjChecked && !cpfCnpjOk"
                    >
                      CPF/CNPJ inválido
                    </div>
                  </div>
                  <vue-recaptcha
                    class="offset-md-4 col-sm-12"
                    :sitekey="recaptchaKey"
                    @verify="onVerifyCReaptcha"
                    @expired="recaptchaOk = false"
                  ></vue-recaptcha>
                </div>
              </div>
              <HR />

              <div class="row">
                <div class="form-group col-sm-12 col-md-6">
                  <div class="form-group col">
                    <label for="email">Email de confirmação:</label>
                    <input
                      class="form-control"
                      type="email"
                      id="email"
                      placeholder="Digite seu email"
                      v-model="form.email"
                    />
                  </div>
                </div>
                <div class="form-group col-sm-12 col-md-6">
                  <div class="form-group col">
                    <label for="tipoPagamento">Tipo de pagamento:</label>
                    <select
                      name="tipoPagamento"
                      v-model="form.tipoPagamento"
                      class="form-control"
                      id="tipoPagamento"
                    >
                      <option value="credit_card">CARTÃO DE CRÉDITO</option>
                      <option value="boleto">BOLETO</option>
                      <!-- <option value="ted">TED</option> -->
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <button
                      type="submit"
                      @click="step = 0"
                      class="col mt-1 align-self-end btn-md btn btn-primary"
                    >
                      <font-awesome-icon icon="chevron-up" />Escolher pacote
                    </button>
                  </div>
                  <div class="col">
                    <button
                      type="submit"
                      @click="checkPagamento()"
                      class="col mt-1 align-self-end btn-md btn btn-success"
                    >
                      Pagamento
                      <font-awesome-icon icon="chevron-down" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingTwo">
            <h2 class="mb-0">
              <button
                class="btn collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                Passo 3: Resumo da recarga
              </button>
            </h2>
          </div>
          <div id="collapseTwo" class="collapse" :class="{ show: step == 2 }">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="card">
                    <div class="card-header">Dados finais da recarga</div>
                    <div class="card-body card-body-dark">
                      <blockquote class="blockquote mb-0">
                        <p class="dadosRecarga">
                          Valor da recarga:
                          <big style="color: green">{{
                            form.planoSelecionado.valor | money
                          }}</big>
                        </p>
                        <p class="dadosRecarga">
                          Valor por sms:
                          <big style="color: green">{{
                            form.planoSelecionado.valorUn | money(3)
                          }}</big>
                        </p>
                        <p class="dadosRecarga">
                          Total de smss:
                          <big style="color: red">{{
                            form.planoSelecionado.totalSmss
                          }}</big>
                        </p>
                        <p class="dadosRecarga">
                          CPF/CNPJ:
                          <big style="color: red">{{
                            form.cpfcnpj | cpfcnpj
                          }}</big>
                        </p>
                        <p class="dadosRecarga">
                          Email de contato:
                          <big style="color: yellow">{{ form.email }}</big>
                        </p>
                        <p class="dadosRecarga">
                          Tipo de pagamento:
                          <big>{{ getTipoPagamento(form.tipoPagamento) }}</big>
                        </p>
                      </blockquote>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card">
                    <div class="card-header">Solicitação preparada</div>
                    <!-- <div class="card-body card-body-dark" v-if="form.tipoPagamento == 'ted'">
                      <blockquote class="blockquote mb-0" >
                        <p class="dadosRecarga">Você deverá fazer uma TED na conta que informaremos a seguir</p>
                        <p class="dadosRecarga">Após a confirmação do pagamento, é feita a liberação do saldo</p>
                        <small class="warningPagamento">*Você deve confirmar a recarga no botão abaixo para concluir a operação</small>
                      </blockquote>
                    </div>-->
                    <div
                      class="card-body card-body-dark"
                      v-if="form.tipoPagamento == 'boleto'"
                    >
                      <blockquote class="blockquote mb-0">
                        <p class="dadosRecarga">
                          Após a confirmação do pagamento, é feita a liberação
                          do saldo
                        </p>
                        <small class="warningPagamento"
                          >*Você deve confirmar a recarga no botão abaixo para
                          concluir a operação</small
                        >
                      </blockquote>
                    </div>
                    <div
                      class="card-body card-body-dark"
                      v-if="form.tipoPagamento == 'credit_card'"
                    >
                      <blockquote class="blockquote mb-0">
                        <p class="dadosRecarga">
                          O valor da compra será aplicado imediatamente em seu
                          cartão
                        </p>
                        <p class="dadosRecarga">
                          Após a confirmação do pagamento pelo cartão, é feita a
                          liberação do saldo
                        </p>
                        <small class="warningPagamento"
                          >*Você deve confirmar a recarga no botão abaixo para
                          concluir a operação</small
                        >
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <div class="col-sm-12">
                <div class="row" v-if="!processandoPagamento">
                  <button
                    type="submit"
                    @click="step = 1"
                    class="col-md-6 btn-md align-self-end btn btn-primary mt-1"
                  >
                    <font-awesome-icon icon="chevron-up" />Alterar dados
                  </button>
                  <button
                    type="submit"
                    @click="confirm()"
                    class="col-md-6 btn-md align-self-end btn btn-success mt-1"
                  >
                    Confirmar recarga
                    <font-awesome-icon icon="check" />
                  </button>
                </div>
                <div class="row mt-2" v-if="processandoPagamento">
                  <div
                    class="col-sm-12 col-md-12 offset-lg-3 col-lg-6 text-center alert alert-info"
                  >
                    <img
                      src="./../../assets/spinner.svg"
                      height="50px"
                      width="50px"
                    />
                    Aguarde, processando compra...
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingThree">
            <h2 class="mb-0">
              <button
                class="btn collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Passo 4: Detalhes da recarga
              </button>
            </h2>
          </div>
          <div id="collapseThree" class="collapse" :class="{ show: step == 3 }">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="col mt-3 alert alert-success">
                    Processo concluído com sucesso.Confira os detalhes abaixo
                  </div>
                </div>
                <div class="col">
                  <div class="card">
                    <div class="card-header success">
                      Dados da recarga solicitada
                    </div>
                    <div class="card-body card-body-dark">
                      <blockquote class="blockquote mb-0">
                        <p class="dadosRecarga">Id: {{ recarga._id }}</p>
                        <p class="dadosRecarga">
                          Valor da recarga: {{ recarga.valor | money }}
                        </p>
                        <p class="dadosRecarga">
                          Valor por sms: {{ recarga.valorUnitario | money(3) }}
                        </p>
                        <p class="dadosRecarga">
                          Total de smss: {{ recarga.totalSmss }}
                        </p>
                        <p class="dadosRecarga">
                          CPF/CNPJ: {{ recarga.cpfcnpj | cpfcnpj }}
                        </p>
                        <p class="dadosRecarga">
                          Email de contato: {{ recarga.emailConfirmacao }}
                        </p>
                        <p class="dadosRecarga">
                          Tipo de pagamento:
                          {{ getTipoPagamento(recarga.tipoPagamento) }}
                        </p>
                      </blockquote>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card">
                    <div class="card-header warning">
                      Solicitação finalizada
                    </div>
                    <div class="card-body card-body-dark">
                      <blockquote class="blockquote mb-0">
                        <p v-if="linkPagamento !== ''"  class="dadosRecarga">
                          Clique no link abaixo para realizar o pagamento
                        </p>
                        <span v-if="linkPagamento !== ''" class="dadoBoleto">
                            <a class="warningPagamento" target="_blank"  :href="linkPagamento"
                              >Realizar Pagamento</a
                            >
                          </span>
                        <p class="dadosRecarga">
                          Após a confirmação do pagamento, é feita a liberação
                          do saldo
                        </p>
                        <small v-if="form.tipoPagamento === 'boleto'" class="warningPagamento"
                          >*O pagamento do boleto pode levar até três dias para
                          ser processado</small
                        >
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <div class="row">
                <div class="col">
                  <button
                    type="submit"
                    @click="reset()"
                    class="col-12 btn btn-success"
                  >
                    Nova recarga
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mt-2">
      <my-alert
        class="alert-success col-12 text-center"
        @done="showSuccess = false"
        :message="successMessage"
        :show="showSuccess"
      ></my-alert>
      <my-alert
        class="alert-danger col-12 text-center"
        @done="showError = false"
        :message="errorMessage"
        :show="showError"
        :timeout="10000"
      ></my-alert>
    </div>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import { VStepper } from 'vue-stepper-component';
import cnpfCnpjValidator from './../../core/cnpfCnpjValidator';
import VueRecaptcha from 'vue-recaptcha';

export default {
  data() {
    return {
      processandoPagamento: false,
      recaptchaOk: false,
      cpfCnpjChecked: false,
      cpfCnpjOk: false,
      showError: false,
      recaptchaKey: process.env.VUE_APP_RECAPTCHA_KEY,
      linkPagamento: '',
      errorMessage: '',
      step: 0,
      form: {
        cpfcnpj: '',
        email: '',
        tipoPagamento: 'credit_card',
        planoSelecionado: {},
        pagarme: {},
      },
      recarga: {},
      boletoGerado: {},
      ted: {},
      planos: [],
    };
  },
  async mounted() {
    this.decoded = jwtDecode(this.$store.getters.authToken);
    this.planos = await this.$http.get('/v1/recargas/getPlanos');
  },
  methods: {
    async onVerifyCReaptcha(resposta) {
      const resp = await this.$http.post('/v1/recargas/validaRecaptcha', {
        resposta,
      });

      if (resp.success) {
        this.recaptchaOk = true;
      } else {
        this.$toasted.show('Erro ao validar reCAPTCHA', {
          icon: 'times',
          type: 'error',
        });
      }
    },
    getTipoPagamento(tipo) {
      switch (tipo) {
        case 'boleto':
          return 'BOLETO';
        case 'credit_card':
          return 'CARTÃO DE CRÉDITO';
        default:
          return 'CARTÃO DE CRÉDITO';
      }
    },
    validaCpfCnpj() {
      let valid = false;

      if (this.form.cpfcnpj.length === 11) {
        valid = cnpfCnpjValidator.isValidCpf(this.form.cpfcnpj);
      } else if (this.form.cpfcnpj.length > 11) {
        valid = cnpfCnpjValidator.isValidCnpj(this.form.cpfcnpj);
      }

      this.cpfCnpjOk = valid;
      this.cpfCnpjChecked = true;

      // if (!valid) {
      //   this.$refs.cpfcnpj.$el.focus()
      // }
    },
    checkPagamento() {
      if (
        !this.form.planoSelecionado ||
        this.form.cpfcnpj.length < 11 ||
        !this.form.email ||
        !this.recaptchaOk ||
        !this.cpfCnpjOk
      ) {
        this.$toasted.show(
          'Complete todos os campos, informe um cpf válido e marque o reCAPTCHA ',
          { icon: 'times', type: 'error' },
        );
      } else {
        this.step = 2;
      }
    },
    reset() {
      this.form = {
        planoSelecionado: {},
        cpfcnpj: '',
        email: '',
        tipoPagamento: 'credit_card',
        pagarme: {},
      };
      this.linkPagamento = '';
      this.step = 0;
      this.showError = false;
      this.errorMessage = '';
    },
    async confirm() {
      this.processandoPagamento = true;
      
      const response = await this.$http.post(
        '/v1/recargas/recargaViaPagarme',
        this.form,
      );
      this.processandoPagamento = false;

      if (response.success) {
        this.recarga = response.recarga;
        this.linkPagamento = response.link;

        window.open(this.linkPagamento, '_blank');
        this.step = 3;
      } else {
        this.showError = true;
        this.errorMessage = response.err;
      }
    },
  },
  components: {
    VStepper,
    VueRecaptcha,
  },
};
</script>

<style>
.btnPagarme {
  background-color: orange;
}

.titleCardRecarga {
  font-size: 15px;
}

.card-pacote:hover .card-body {
  background-color: #fff !important;
  color: #212529;
  cursor: pointer;
}

.card-pacote:hover .card-header {
  background-color: #212529 !important;
  color: #fff;
}

.dadosRecarga {
  font-size: 14px;
}

.warningPagamento {
  font-size: 10px;
  color: orange;
}

.valor,
.faixa {
  font-size: 10px !important;
}

div.v-stepper > div.v-stepper-root > div.v-step {
  pointer-events: none;
}

#fazerRecarga .card-header .btn {
  color: white !important;
  padding-left: 0px;
  padding-right: 0px;
  text-align: center;
}

.infoPlanoSelecionado {
  font-weight: bold;
}

.dadoBoleto,
.dadoBoleto a {
  font-size: 14px;
  color: orange;
  font-weight: bold;
}
/* melhorPreo */
</style>
